// extracted by mini-css-extract-plugin
export default {"profile__popper":"ProfileDetails_profile__popper__Lj-9-","profile__body":"ProfileDetails_profile__body__VvLOo"};